import { render, staticRenderFns } from "./update-beneficiaries-wrapper.component.vue?vue&type=template&id=5606499f&"
import script from "./update-beneficiaries-wrapper.component.vue?vue&type=script&lang=ts&"
export * from "./update-beneficiaries-wrapper.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports